import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import Select from 'react-select';
import { DatePicker } from 'antd';
import { Field, getFormSubmitErrors, reduxForm, SubmissionError } from 'redux-form';
import { Link } from 'react-router-dom';
import { Button } from '@kambria/kambria-lego';
import { IntlPhoneInput, PublicLink } from 'views/components/core/ReduxForm.js';
import {
  checkPublicUsername,
  fetchAllReferences,
  setEditting,
  updateUserInfo,
  fetchUserMvp,
  getUserProfileMvp,
} from 'redux/actions/user.action';
import utils from 'helpers/utils';
import constants from 'helpers/const';
import { getDaoDetailByCode } from 'redux/actions/mvp/tecd-package.action.js';
import Web3 from 'web3';
import { I18n } from '../../../../helpers/i18n';

const FORM_NAME = 'formUserProfile';
const { USER_EXPERIENCES } = constants;

const formatExperienceForSelect = (experience) => {
  if (experience) {
    return {
      label: utils.getUserExperienceLabel(experience),
      value: experience,
    };
  }
};

const formatValueForMultiSelect = (data) => {
  return (data && data.map((value) => ({ label: value, value }))) || [];
};

const formatValueForSelect = (value) => {
  return (value && { label: value, value }) || '';
};

const customSelectStyles = {
  control: (_, { selectProps: { isDisabled } }) => {
    return {
      background: isDisabled ? '#e9ecef' : '#FFF',
      borderRadius: 8,
      minHeight: 46,
      display: 'flex',
      border: '1px solid #cfcfcf',
    };
  },
};

const INPUT_FIELDS = ['firstName'];
const SELECT_FIELDS = [];
const MULTI_SELECT_FIELDS = [];

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      completePercent: 0,
    };
  }

  async componentDidMount() {
    const { getDaoDetailByCode } = this.props;

    const { fetchAllReferences, initialValues, getUserProfileMvp, fetchUserMvp } = this.props;
    await fetchAllReferences();
    const daoInfo = await getDaoDetailByCode('TECD');
    this.setState({ daoInfo: daoInfo?.data?.data });

    // const userProfile = await getUserProfileMvp();
    // console.log("userProfile", userProfile)
  }
  connectMetamask = async () => {
    let account = null;
    if (typeof window.ethereum !== 'undefined') {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.setState({ userWalletID: accounts[0], metamaskStatus: !!accounts[0] });
        account = accounts[0];
        // Listen for account changes
        window.ethereum.on('accountsChanged', (accounts) => {
          // Use arrow function to maintain 'this' context
          this.setState({ userWalletID: accounts[0] });
        });
      } catch (error) {
        console.error('Error connecting to MetaMask:', error);
      }
    } else {
      alert('Please install MetaMask to use this feature');
    }
    return account;
  };

  claimPaymentAction = async (chainId, microjobPaymentAddress, account) => {
    // console.log("ProcessorAddress", ServiceRevenueSharingAddress)
    const MicrojobPaymentABI = [
      {
        inputs: [
          { internalType: 'address', name: '_xdaoAddress', type: 'address' },
          { internalType: 'address', name: '_KATAddress', type: 'address' },
          { internalType: 'address', name: '_USDTAddress', type: 'address' },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
          { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'bytes32', name: 'previousAdminRole', type: 'bytes32' },
          { indexed: true, internalType: 'bytes32', name: 'newAdminRole', type: 'bytes32' },
        ],
        name: 'RoleAdminChanged',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'address', name: 'account', type: 'address' },
          { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleGranted',
        type: 'event',
      },
      {
        anonymous: false,
        inputs: [
          { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { indexed: true, internalType: 'address', name: 'account', type: 'address' },
          { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleRevoked',
        type: 'event',
      },
      {
        inputs: [],
        name: 'ADMIN_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'DEFAULT_ADMIN_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'KATAddress',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'TRANSACTION_IMPLEMENTOR_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'USDTAddress',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'uint256', name: '_USDTAmount', type: 'uint256' },
          { internalType: 'uint256', name: '_EquivalentKATPerUSDT', type: 'uint256' },
        ],
        name: 'calculateBalances',
        outputs: [
          {
            components: [
              { internalType: 'uint256', name: 'katBalanceOnUSDTWei', type: 'uint256' },
              { internalType: 'uint256', name: 'usdtWeiBalance', type: 'uint256' },
            ],
            internalType: 'struct MicroJobPayment.Balances',
            name: 'retBalances',
            type: 'tuple',
          },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      { inputs: [], name: 'claim', outputs: [], stateMutability: 'nonpayable', type: 'function' },
      {
        inputs: [{ internalType: 'address', name: '', type: 'address' }],
        name: 'claimerList',
        outputs: [
          { internalType: 'address', name: 'wallet', type: 'address' },
          { internalType: 'uint256', name: 'withdrawableinKAT', type: 'uint256' },
          { internalType: 'uint256', name: 'withdrawableinUSDT', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
        name: 'getRoleAdmin',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'grantRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'hasRole',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        name: 'lastLpHolderList',
        outputs: [
          { internalType: 'address', name: 'wallet', type: 'address' },
          { internalType: 'uint256', name: 'balance', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'paymentPerSession',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        name: 'purchaseTimestamps',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
      },
      { inputs: [], name: 'renounceOwnership', outputs: [], stateMutability: 'nonpayable', type: 'function' },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'renounceRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'bytes32', name: 'role', type: 'bytes32' },
          { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'revokeRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'uint256', name: '_paymentPerSession', type: 'uint256' }],
        name: 'setPaymentPerSession',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [
          { internalType: 'address[]', name: 'wallets', type: 'address[]' },
          { internalType: 'uint256[]', name: 'numbersOfCompletedSession', type: 'uint256[]' },
          { internalType: 'uint256', name: 'usdtAmount', type: 'uint256' },
          { internalType: 'uint256', name: 'equivalentKATPerUSDT', type: 'uint256' },
        ],
        name: 'submitCalculationData',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
        name: 'supportsInterface',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        name: 'transactionDone',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
      {
        inputs: [],
        name: 'viewAllCalculations',
        outputs: [
          {
            components: [
              {
                components: [
                  { internalType: 'address', name: 'wallet', type: 'address' },
                  { internalType: 'uint256', name: 'withdrawableinKAT', type: 'uint256' },
                  { internalType: 'uint256', name: 'withdrawableinUSDT', type: 'uint256' },
                ],
                internalType: 'struct MicroJobPayment.Claimer[]',
                name: 'claimers',
                type: 'tuple[]',
              },
              { internalType: 'uint256', name: 'timestamp', type: 'uint256' },
            ],
            internalType: 'struct MicroJobPayment.PaymentCalculation[]',
            name: '',
            type: 'tuple[]',
          },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'viewAllClaimTransactions',
        outputs: [
          {
            components: [
              { internalType: 'address', name: 'claimer', type: 'address' },
              { internalType: 'uint256', name: 'claimedAmountInKAT', type: 'uint256' },
              { internalType: 'uint256', name: 'claimedAmountInUSDT', type: 'uint256' },
              { internalType: 'uint256', name: 'timestamp', type: 'uint256' },
            ],
            internalType: 'struct MicroJobPayment.ClaimTransaction[]',
            name: '',
            type: 'tuple[]',
          },
        ],
        stateMutability: 'view',
        type: 'function',
      },
      {
        inputs: [],
        name: 'xdaoAddress',
        outputs: [{ internalType: 'contract IDao', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
      },
    ];
    let web3 = null;
    web3 = new Web3(window.ethereum);

    if (microjobPaymentAddress) {
      // console.log("ProcessorAddress", ServiceRevenueSharingAddress)

      const MicroJobPaymentContract = new web3.eth.Contract(MicrojobPaymentABI, microjobPaymentAddress);
      // console.log("CodebaseLicensingProcessorContract", ServiceRevenueSharingContract)

      try {
        const gasPrice = web3.utils.toWei('80', 'gwei'); // Đặt giá gas là 80 Gwei

        let result = await MicroJobPaymentContract.methods.claim().send({
          from: account,
          gas: 3000000, // Đặt giới hạn gas cao hơn nếu cần
          gasPrice: gasPrice, // Sử dụng giá gas đã chuyển đổi
        }); // console.log("result", result);
      } catch (error) {
        // Xử lý lỗi nếu cần thiết
        console.log(error);

        return [];
      }
      // Sau khi lấy xong thì có thể thực hiện các bước khác tại đây
    }
  };
  claimPayment = async (chainId, microjobPaymentAddress) => {
    const account = await this.connectMetamask();
    let isValid = true;
    let web3 = null;
    if (account && typeof window.ethereum !== 'undefined') {
      if (window.ethereum) {
        web3 = new Web3(window.ethereum);
      } else {
        console.error('Ethereum object not found, make sure you have a web3 provider.');
        return false;
      }
      const networkId = await web3.eth.net.getId();
      if (parseFloat(networkId) === parseFloat(chainId)) {
        await this.claimPaymentAction(chainId, microjobPaymentAddress, this.state.userWalletID);
      } else {
        alert('Wrong network. Please change your wallet network to Chain ID ' + chainId);
        window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: web3.utils.toHex(chainId) }],
        });
        isValid = false;
      }
    }
    return isValid;
  };
  onEditClick = () => {
    this.props.setEditting(true);
  };

  onCancel = () => {
    const { reset } = this.props;
    reset();

    this.props.setEditting(false);
  };

  validateFormData = async ({ phoneNumber, endYear, publicUsername, ...values }) => {
    const { user, checkPublicUsername } = this.props;
    const errors = {};
    // INPUT_FIELDS.forEach((key) => {
    //   if (!values[key] || !values[key].trim().length) {
    //     errors[key] = 'required';
    //   }
    // });

    // SELECT_FIELDS.forEach((key) => {
    //   if (!values[key] || !values[key].value) {
    //     errors[key] = 'required';
    //   }
    // });

    // MULTI_SELECT_FIELDS.forEach((key) => {
    //   if (!values[key] || !values[key].length) {
    //     errors[key] = 'required';
    //   }
    // });

    // if (!phoneNumber || !phoneNumber.number || !utils.validatePhoneNumber(phoneNumber.dialCode, phoneNumber.number)) {
    //   errors.phoneNumber = 'incorrect phone number';
    // }

    // if (!publicUsername.trim().length) {
    //   errors.publicUsername = 'required';
    // } else if (publicUsername.trim().length < 5) {
    //   errors.publicUsername = 'must be at least 5 characters';
    // } else if (publicUsername.trim().length > 50) {
    //   errors.publicUsername = 'max length exceeded';
    // } else if (/[^a-zA-Z0-9.]/g.test(publicUsername.trim())) {
    //   errors.publicUsername = 'contains invalid characters';
    // } else if (publicUsername !== user.publicUsername) {
    //   const result = await checkPublicUsername(publicUsername);
    //   if (result.message) {
    //     errors.publicUsername = result.message;
    //   }
    // }
    return errors;
  };

  onBtnUpdateClick = async (values) => {
    const { updateUserInfo, setEditting, submitErrors, fetchUserMvp } = this.props;
    const errors = Object.keys(submitErrors).length ? submitErrors : await this.validateFormData(values);
    if (Object.keys(errors).length) throw new SubmissionError(errors);
    const selectFieldValues = SELECT_FIELDS.reduce((result, key) => {
      result[key] = values[key].value;
      return result;
    }, {});
    const multiSelectFieldValues = MULTI_SELECT_FIELDS.reduce((result, key) => {
      result[key] = values[key].map((item) => item.value);
      return result;
    }, {});
    const finalValues = { ...values, ...selectFieldValues, ...multiSelectFieldValues };
    updateUserInfo({ ...values, ...selectFieldValues, ...multiSelectFieldValues }, () => {
      fetchUserMvp();
      setEditting(false);
    });
  };

  renderInput = ({ input, label, type, meta: { touched, error }, disabled, col = 6 }) => {
    return (
      <div className={`form-item col-12 col-xl-${col} col-lg-${col} col-md-12 col-sm-12`}>
        <span className="label d-block mt-3 mb-2">
          {label} {touched && error && <small className="error">{error}</small>}
        </span>
        <input {...input} disabled={disabled} className="w-100 form-control" type={type} />
      </div>
    );
  };

  render() {
    console.log('render called');

    const { handleSubmit, editting, references, user } = this.props;
    const { completePercent } = this.state;
    return (
      <div className="px-4 user-profile">
        <h3 className="title mt-3 mb-0">{I18n.t('my_account')}</h3>

        <form className="col-12 px-0" onSubmit={handleSubmit(this.onBtnUpdateClick)}>
          <div className="row">
            <Field disabled={!editting} name="firstName" label={I18n.t('senior_account_account_info_fullname_label')} component={this.renderInput} />
            <Field disabled label={I18n.t('senior_account_account_info_email_label')} name="email" component={this.renderInput} />
          </div>

          <div className="row">
            <Field disabled={!editting} name="walletAddress" label={I18n.t('wallet_address')} component={this.renderInput} />
            <Button
              type="primary"
              size="sm"
              customStyle={{ marginTop: 50, marginLeft: 15, height: '45px' }}
              onClick={() => this.claimPayment(this.state.daoInfo.chainId, this.state.daoInfo.microjobPaymentAddress)}
            >
              {I18n.t('withdraw_money')}
            </Button>
          </div>

          {editting ? (
            <div>
              <button
                type="submit"
                className="btn btn-primary"
                style={{ marginTop: 30, marginRight: 12, padding: '4px 24px' }}
                disabled={!!this.props.updating}
              >
                {I18n.t('change_password_button_title')}
              </button>
              <button
                type="button"
                className="btn"
                style={{ marginTop: 30, padding: '4px 24px' }}
                onClick={this.onCancel}
              >
                {I18n.t('cancel')}
              </button>
            </div>
          ) : (
            <Button type="primary" size="sm" customStyle={{ marginTop: 30 }} onClick={this.onEditClick}>
              {I18n.t('edit')}
            </Button>
          )}
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { user } = state;
  // console.log("uinitialValues", initialValues)
  console.log('user', user);
  return {
    user,
    editting: user.editting,
    updating: user.updating,
    references: user.references,
    initialValues: {
      _id: user._id,
      firstName: user.firstName || user.name || '',
      walletAddress: user.walletAddress || '',
      email: user.email || '',
      phoneNumber: user.phoneNumber,
    },
    submitErrors: getFormSubmitErrors(FORM_NAME)(state),
  };
};

const mapDispatchToProps = {
  setEditting,
  updateUserInfo,
  fetchAllReferences,
  checkPublicUsername,
  fetchUserMvp,
  getUserProfileMvp,
  getDaoDetailByCode,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: FORM_NAME,
  })(Profile),
);
